import styled, { css } from 'styled-components';
import Theme from 'Theme';

export const SubTitle = styled.div`
  color: ${props => props.color || Theme.mediumGrey};
  font-size:  ${props => props.size || '14px'};
  line-height: 1.2em;
  margin-bottom: 8px;
  font-family: ${Theme.primaryFont};
`;

export const Title = styled.div`
  color: ${props => props.color || Theme.brandColor};
  font-size: 18px;
  line-height: 1.2em;
  font-weight: 600;
  margin-bottom: 4px;
  font-family: ${Theme.primaryFont};
`;

export const Total = styled.div`
  color: ${props => props.color || Theme.successColor};
  font-size:  ${props => props.size || '24px'};
  line-height: 1.2em;
  margin-bottom: 4px;
  font-family: ${Theme.primaryFont};
`;

export const FieldError = styled.div`
  font-size: 16px;
  color: ${Theme.dangerColor};
  font-family: ${Theme.primaryFont};
`;

export const Default = styled.div`
  font-size: ${props => props.size || '14px'};

  line-height: ${props => props.lineHeight ? props.lineHeight : '1.2em'};
  font-weight: ${props => props.bold ? '600' : props.fontWeight ? props.fontWeight : 'unset'}

  color: ${props => props.color || Theme.fontColor};
  font-family: ${Theme.primaryFont};

  ${({ center }) => center && css`
    text-align: center;
  `};
`;

export const Info = styled(Default)`
  font-size: 1em;
  color: #333;
  font-weight: 300;
  margin: 1em 0em;
`;
